// FOXSELL: Bundle Configuration Module
const FoxsellBundleConfig = {
  _config: null,
  _initialized: false,
  _lockedMetal: null,

  init() {
    if (this._initialized) return;
    
    if (!window.foxsell?.bundleConfig) {
      console.log('Foxsell bundle configuration not found');
      return;
    }

    this._config = window.foxsell.bundleConfig;
    this._initialized = true;
  },

  get options() {
    if (!this._initialized) this.init();
    return this._config?.options || {};
  },

  get categories() {
    if (!this._initialized) this.init();
    return this._config?.categories || [];
  },

  get settings() {
    if (!this._initialized) this.init();
    return this._config?.settings || {};
  },

  get products() {
    if (!this._initialized) this.init();
    return this._config?.products || [];
  },

  get addOnProducts() {
    if (!this._initialized) this.init();
    return this._config?.addOnProducts || [];
  },

  get addOnProductProperties() {
    if (!this._initialized) this.init();
    return this._config?.addOnProductProperties || {};
  },

  get bundleId() {
    if (!this._initialized) this.init();
    return this._config?.id;
  },

  // New getters for alt_min and mixed_metals
  get altMin() {
    if (!this._initialized) this.init();
    return this._config?.alt_min || null;
  },

  get mixedMetals() {
    if (!this._initialized) this.init();
    // Access the raw config value directly
    return this._config?.mixed_metals;
  },

  // Helper method to check if mixed metals are allowed
  allowsMixedMetals() {
    // Only return false if mixed_metals is explicitly set to false
    const allowsMixed = this._config?.mixed_metals !== false && this._config?.mixed_metals !== "false";

    return allowsMixed;
  },

  // Helper method to get minimum category requirements
  getCategoryMinimum(categoryTitle) {
    if (!this.altMin) return null;
    
    // Check if alt_min is a single category-min pair or a comma-separated list
    if (this.altMin.includes(',')) {
      // Parse the alt_min string which is in format "category1-min1,category2-min2"
      const minRequirements = this.altMin.split(',').reduce((acc, curr) => {
        const [category, min] = curr.split('-');
        acc[category.trim().toLowerCase()] = parseInt(min);
        return acc;
      }, {});
      
      // Return the minimum requirement for the specific category, or null if not found
      return minRequirements[categoryTitle.toLowerCase()] || null;
    } else {
      // Handle the case where alt_min is a single "category_name-#" pair
      const [category, min] = this.altMin.split('-');
      if (category.trim().toLowerCase() === categoryTitle.toLowerCase()) {
        return parseInt(min);
      }
      return null;
    }
  },

  // Helper method to get a specific option value
  getOption(key) {
    return this.options[key];
  },

  // Helper method to get a product by ID
  getProductById(id) {
    return this.products.find(p => p.id === id);
  },

  // Helper method to get add-on product properties for a specific product
  getAddOnProductProperties(productId) {
    return this.addOnProductProperties[productId]?.variants || {};
  },

  // Category-specific helper methods
  getCategoryByTitle(title) {
    return this.categories.find(cat => cat.title === title);
  },

  getCategoryQuantity(title) {
    const category = this.getCategoryByTitle(title);
    return category?.quantity || 0;
  },

  getCategoryProducts(title) {
    const category = this.getCategoryByTitle(title);
    return category?.products || [];
  },

  getCategoryIndex(title) {
    return this.categories.findIndex(cat => cat.title === title);
  },

  getNextCategory(currentTitle) {
    const currentIndex = this.getCategoryIndex(currentTitle);
    return this.categories[currentIndex + 1];
  },

  getPreviousCategory(currentTitle) {
    const currentIndex = this.getCategoryIndex(currentTitle);
    return this.categories[currentIndex - 1];
  },

  // Bundle completion helpers
  getRequiredQuantityForCategory(title) {
    return this.getCategoryQuantity(title);
  },

  getRemainingQuantityForCategory(title, currentCount) {
    const required = this.getRequiredQuantityForCategory(title);
    return Math.max(0, required - currentCount);
  },

  isCategoryComplete(title, currentCount) {
    return currentCount >= this.getRequiredQuantityForCategory(title);
  },

  getTotalRequiredItems() {
    return this.categories.reduce((total, cat) => total + cat.quantity, 0);
  },

  getRemainingTotalItems(currentCounts) {
    return this.categories.reduce((total, cat) => {
      const currentCount = currentCounts[cat.title] || 0;
      return total + this.getRemainingQuantityForCategory(cat.title, currentCount);
    }, 0);
  },

  get lockedMetal() {
    return this._lockedMetal;
  },

  set lockedMetal(value) {
    this._lockedMetal = value;
    this.updateMetalLockUI();
  },

  updateMetalLockUI() {
    const foxsellBundler = document.getElementById('foxsell-bundles');
    if (!foxsellBundler) return;

    // Get all metal fieldsets except in the first category
    const metalFieldsets = foxsellBundler.querySelectorAll('.bundler-category:not(:first-child) fieldset.Metal');
    
    // Only apply restrictions if mixed_metals is explicitly false
    if (!this.allowsMixedMetals() && this._lockedMetal) {
      metalFieldsets.forEach(fieldset => {
        // Hide the fieldset
        fieldset.classList.add('visually-hidden');
        
        // Find and check the matching metal input
        const metalInput = fieldset.querySelector(`input[value="${this._lockedMetal}"]`);
        if (metalInput) {
          metalInput.checked = true;
          metalInput.dispatchEvent(new Event('change'));
        } else {
          console.warn('Could not find matching metal input for value:', this._lockedMetal);
        }
      });
    } else {
      metalFieldsets.forEach(fieldset => {
        fieldset.classList.remove('visually-hidden');
      });
    }
  }
};

// Initialize the config when the DOM is ready
document.addEventListener('DOMContentLoaded', () => {
  // Small delay to ensure window.foxsell is available from liquid template
  setTimeout(() => {
    FoxsellBundleConfig.init();
  }, 100);
});

// on page load, find and disable the add to cart button and find foxsell 
document.addEventListener('DOMContentLoaded', () => {
  // Skip this for flatback bundler
  const flatbackBundler = document.getElementById('foxsell-bundles-flatback');
  if (flatbackBundler) return;
  
  const addToCartBtn = document.getElementById('addToCartButton');
  if (addToCartBtn) {
    addToCartBtn.textContent = "Choose your options";
    addToCartBtn.disabled = true;
  }
});

// gets all the bundler categories and starts selectedProducts array with objects for each category
const bundlerCategories = document.querySelectorAll('.bundler-category');
const selectedProducts = [];
bundlerCategories.forEach(bundlerCategory => {
  const category = bundlerCategory.dataset.category;
  selectedProducts.push({
    category: category,
    variantId: '',
    quantity: 1,
    type: 'product',
    price: 0,
    properties: {}
  });
});

// Shows and hides the bundler category variant options
function toggleClassBasedOnDataUrl() {
  const labels = document.querySelectorAll('label[data-product-title]');
  labels.forEach(label => {
    label.addEventListener('click', () => {
      label.parentElement.querySelector('input[type="radio"]').checked = true;
      const labelProductUrl = label.getAttribute('data-product-title');
      const variantRadiosElements = label.parentElement.parentElement.nextElementSibling.querySelectorAll('variant-radios');
      variantRadiosElements.forEach(variantRadios => {
        const variantDataUrl = variantRadios.getAttribute('data-vars-title');
        if (labelProductUrl === variantDataUrl) {
          variantRadios.classList.add('display-vars');
          variantRadios.classList.remove('hidden-vars');
          checkThoseBoxes(variantRadios);
        } else {
          variantRadios.classList.add('hidden-vars');
          variantRadios.classList.remove('display-vars');
        }
      });
    });
  });
}
let foxsellBundler = document.getElementById('foxsell-bundles');
if (foxsellBundler && !foxsellBundler.classList.contains('multi-step-bundler')) {
  toggleClassBasedOnDataUrl();
}

// intercepts click events on the variant labels add and remove the event listener variantLabelClickHandler
function checkThoseBoxes(variantRadios) {
  let variantLabels = variantRadios.querySelectorAll('fieldset label');
  variantLabels.forEach(variantLabel => {
    variantLabel.removeEventListener('click', variantLabelClickHandler);
    variantLabel.addEventListener('click', variantLabelClickHandler);
  });
}

// sets the checked attribute on the radio button and updates the ATC button
function variantLabelClickHandler() {
  let thisLabel = this.dataset.name;
  let thisInput = this.parentElement.querySelector(`input[type="radio"][value="${thisLabel}"]`);
  thisInput.checked = true;
  let addToCartBtn = document.getElementById('addToCartButton');
  if (!!addToCartBtn) {
    const bundlerType = this.closest('[data-bundler-type]')?.dataset.bundlerType;
    const category = this.closest('.bundler-category').dataset.category;
    // Always update properties first if this is a properties input
    if (bundlerType === 'properties') {
      updateProductProperties(category, addToCartBtn);
      // After updating properties, check if we need to update variants
      const productContainer = this.closest('.bundler-category');
      const selectedVariantInput = productContainer.querySelector('input[type="radio"][data-product-handle]:checked');
      if (selectedVariantInput) {
        const thisProductHandle = selectedVariantInput.dataset.productHandle;
        const varScript = document.getElementById(`${thisProductHandle}-vars`);
        if (varScript) {
          getBundlerItems(varScript, addToCartBtn);
        }
      }
    } else if (bundlerType === 'product') {
      let thisProductHandle = thisInput.dataset.productHandle;
      let varScript = document.getElementById(`${thisProductHandle}-vars`);
      if (varScript) {
        getBundlerItems(varScript, addToCartBtn);
      }
      // Update bundler option for product type
      const variantRadios = this.closest('variant-radios');
      if (variantRadios) {
        variantRadios.dataset.bundlerOption = "true";
      }
    } else if (bundlerType === 'add_on') {
      let thisProductHandle = thisInput.dataset.productHandle;
      let varScript = document.getElementById(`${thisProductHandle}-vars`);
      if (varScript) {
        getAddOnItems(varScript, addToCartBtn);
      }
    }
  }
}

// gets the variant data and updates the ATC button after finding a matching variant for bundler type of product
function getBundlerItems(varScript, atcBtn) {
   // Check if varScript exists and has content
   if (!varScript || !varScript.textContent) {
    return;  // Exit the function early if varScript is invalid
  }
  const variantData = JSON.parse(varScript.textContent);
  const categoryContainer = varScript.closest('.bundler-category');
  const category = categoryContainer.dataset.category;
  const selectedProduct = categoryContainer.querySelector('input[type="radio"]:checked');
  if (!selectedProduct || !atcBtn) return;
  // Get all selected options for this product
  const variantRadios = categoryContainer.querySelector('.display-vars');
  const selectedOptions = Array.from(variantRadios.querySelectorAll('fieldset'))
    .map(fieldset => {
      const checkedInput = fieldset.querySelector('input[type="radio"]:checked');
      return checkedInput ? checkedInput.value : null;
    })
    .filter(Boolean);
  // Find matching variant based on selected options
  const matchingVariant = variantData.find(variant => {
    const cleanedVariantOptions = variant.options
      .map(opt => opt.replace(/\\"/g, '').replace(/"/g, ''))
      .filter(opt => opt !== "1");
    
    return cleanedVariantOptions.length === selectedOptions.length && 
          selectedOptions.every((option, index) => cleanedVariantOptions[index] === option);
  });
  if (matchingVariant) {
    const productIndex = selectedProducts.findIndex(product => product.category === category);
    if (productIndex !== -1) {
      const existingProperties = selectedProducts[productIndex].properties || {};
      selectedProducts[productIndex] = {
        ...selectedProducts[productIndex],
        variantId: matchingVariant.id.toString(),
        quantity: 1,
        type: 'product',
        price: matchingVariant.price,
        properties: existingProperties  // Preserve existing properties
      };
    }
    updateAddToCartButton(atcBtn, matchingVariant, category);
    updatePrice(atcBtn, selectedProducts);
  } else {
    atcBtn.disabled = true;
  }
}

// handles the variant radios with bundler type of add_on
function getAddOnItems(varScript, atcBtn) {
  const variantData = JSON.parse(varScript.textContent);
  const addOnContainer = varScript.closest('.add_on_vars');
  const categoryContainer = varScript.closest('.bundler-category');
  const category = categoryContainer.dataset.category;
  const selectedMetal = categoryContainer?.querySelector('input.is-metal:checked');
  if (selectedMetal) {
    // Find and update the matching add-on input
    const matchingAddOnInput = addOnContainer.querySelector(`input[type="radio"][value="${selectedMetal.value}"]`);
    if (matchingAddOnInput) {
      matchingAddOnInput.checked = true;
    }
  }
  const selectedProduct = addOnContainer.querySelector('input[type="radio"]:checked');
  if (!selectedProduct || !atcBtn) return;
  // Get all selected options for this product
  const variantRadios = addOnContainer;
  const selectedOptions = Array.from(variantRadios.querySelectorAll('fieldset'))
    .map(fieldset => {
      const checkedInput = fieldset.querySelector('input[type="radio"]:checked');
      
      return checkedInput ? checkedInput.value : null;
    })
    .filter(Boolean);
  // Find matching variant based on selected options
  // added an option in here to filter out the "1" value because getting this randomly
  const matchingVariant = variantData.find(variant => {
    // Clean the variant options and filter out the "1" value
    const cleanedVariantOptions = variant.options
      .map(opt => opt.replace(/\\"/g, '').replace(/"/g, ''))
      .filter(opt => opt !== "1");
    return cleanedVariantOptions.length === selectedOptions.length && 
          selectedOptions.every((option, index) => cleanedVariantOptions[index] === option);
  });
  if (matchingVariant) {
    // push the matching variant to the selectedProducts array
    selectedProducts.push({
      variantId: matchingVariant.id.toString(),
      quantity: 1,
      type: 'addOns',
      price: matchingVariant.price,
      properties: {}
    }); 
    updateAddToCartButton(atcBtn, matchingVariant, category);
  } else {
    atcBtn.disabled = true;
  }
}

function updateProductProperties(category, atcBtn) {
  const categoryContainer = document.querySelector(`.bundler-category[data-category="${category}"]`);
  const selectedInput = categoryContainer.querySelector('variant-radios[data-bundler-type="properties"] input[type="radio"]:checked');
  if (!selectedInput) {
    return;
  }
  // Find the product for this category
  const productIndex = selectedProducts.findIndex(product => product.category === category);
  if (productIndex !== -1) {
    // Create the property update regardless of variant status
    selectedProducts[productIndex].properties = {
      ...selectedProducts[productIndex].properties,
      [selectedInput.name]: selectedInput.value
    };
  }
  // Check which category needs to be selected next
  updateAddToCartButton(atcBtn, { available: true }, category);
}

// Helper function to clean option values as getting problems for chain length in inches with quotations used in the options
function cleanOptionValue(value) {
  return value
    .replace(/\\"/g, '"') 
    .replace(/['"]/g, '')
    .replace(/\s+/g, ' ') 
    .trim();
}

function updateAddToCartButton(atcBtn, variant, category) {
  if (!variant.available) {
    atcBtn.disabled = true;
    atcBtn.textContent = `Chosen ${category} unavailable`;
    return;
  }

  // Check if all categories have selected variants
  const incompleteCategory = selectedProducts.find(product => !product.variantId);
  
  if (incompleteCategory) {
    atcBtn.disabled = true;
    atcBtn.textContent = `Choose your ${incompleteCategory.category}`;
  } else {
    atcBtn.disabled = false;
    atcBtn.textContent = "Add to Bag";
    // FOXSELL: Preparing line Item Properties
    const bundleLineItemProperties = selectedProducts.map(product => {
      return {
        variantId: product.variantId,
        quantity: product.quantity,
        category: product.category,
        type: product.type,
        properties: product.properties
      }
    })
    addBundlerItemsToCart(atcBtn, bundleLineItemProperties);
  }
}

function updatePrice(atcBtn, selectedProducts) {
  const foxsellContainer = document.getElementById('foxsell-bundles');
  const discountStrategy = foxsellContainer.dataset.discountStrategy;
  const currentPrice = document.querySelector('div.js-main-product-price span.price-item.price-item--regular');
  if (!currentPrice) return;
  let totalPrice = 0;
  selectedProducts.forEach(product => {
    totalPrice += product.price;
  });
  const varPrice = totalPrice / 100;
  const mainProdPrice = Number(atcBtn.getAttribute('data-bundler-main-product-price')) / 100;
  const newPrice = mainProdPrice + varPrice;
  const updatedPrice = newPrice * (100 - discountStrategy)/100;
  currentPrice.textContent = updatedPrice.toLocaleString("en-US", {style:"currency", currency:"USD"});
}

function addBundlerItemsToCart(atcBtn, bundleLineItemProperties){
  async function atcSubmit(event){ 
    event.preventDefault();
    const foxsellContainer = document.getElementById('foxsell-bundles');
    const bundleId = foxsellContainer.dataset.bundleId;
    const currentBundleVariant = foxsellContainer.dataset.currentBundleVariant;
    const currentDate = Date.now();
    const identifier = `${bundleId}_${currentDate}`;

    // console.log('🔍 BUNDLE LINE ITEM PROPERTIES (BEFORE PROCESSING):', bundleLineItemProperties);
    // Only sort and assign positions for multistep bundler
    const isMultiStep = foxsellContainer.classList.contains('multi-step-bundler');
    const processedProperties = isMultiStep ? 
      // Sort and assign positions for multistep
      bundleLineItemProperties.map((item, index) => {
        const itemCopy = { ...item };
        
        // Create a filtered properties object with only essential properties
        const essentialProperties = {
          'Part of': itemCopy.properties['Part of'],
          '_Bundle': itemCopy.properties['_Bundle']
        };

        if (item.category === 'Step 2' || item.category.includes('Charm')) {
          // Calculate charm number based on existing charms
          const charmCount = bundleLineItemProperties
            .slice(0, index)
            .filter(i => i.category === 'Step 2' || i.category.includes('Charm'))
            .length;
          
          essentialProperties._placement = `charm ${charmCount + 1}`;
        } else if (item.category === 'Step 1' || item.category === 'Chain') {
          essentialProperties._placement = 'chain';
        }
        
        // Replace the properties with our filtered version
        itemCopy.properties = essentialProperties;
        
        return itemCopy;
      }) :
      // Use original properties for regular bundler
      bundleLineItemProperties;

    // Build simplified bundle item details for Rebuy cart display
    const bundleItemDetails = bundleLineItemProperties.map(item => {
      // Filter out internal properties (those starting with _ or known system properties)
      const variantOptions = {};

      Object.entries(item.properties).forEach(([key, value]) => {
        // Exclude internal properties
        if (!key.startsWith('_') && key !== 'stepCategory' && key !== 'Part of') {
          variantOptions[key] = value;
        }
      });

      // Build formatted variant title (e.g., "Sterling Silver / 18"")
      const variantTitle = Object.values(variantOptions).join(' / ');

      return {
        title: item.title,
        variantTitle: variantTitle
      };
    });

    const addToCartFormData = [{
      id: currentBundleVariant,
      quantity: 1,
      properties: {
        "__foxsell:dynamic_add_on_bundle_id": identifier,
        "__foxsell:dynamic_add_on_bundle_items": JSON.stringify(processedProperties),
        "__bundle_item_details": JSON.stringify(bundleItemDetails),
        "_custom_product": "True"
      }
    }];

    let bundlerItems = {
      items: addToCartFormData,
      sections: getSectionsToRender().map((section) => section.section),
      sections_url: window.location.pathname
    };
    try {
      let response = await fetch(`/cart/add.js`, {
        method: 'POST',
        headers: {'Content-Type': 'application/json'},
        body: JSON.stringify(bundlerItems)
      });
      if (!response.ok) {
        throw new Error(`Something is up! Status: ${response.status}`);
      }
      const cartNotification = document.getElementById('cart-notification');
      cartNotification.classList.add('active');
      cartNotification.focus();
      let notEmptyCart = document.getElementById('shopify-section-mini-cart');
      notEmptyCart.querySelector('.mini-cart-container').classList.add('not-empty');
      const parsedState = await response.json();
      atcBtn.textContent = "Added to Bag";
      
      // Only update cart sections if the elements exist
      if (document.getElementById('main-cart-items') && document.getElementById('main-cart-footer')) {
        await updateCartSections(parsedState);
      }

      // Only reset queue if we're in multi-step bundler
      const isMultiStep = foxsellContainer.classList.contains('multi-step-bundler');
      if (isMultiStep && bundlerQueue.resetQueue) {
        bundlerQueue.resetQueue();
      }

      setTimeout(() => atcBtn.textContent = "Add to Bag", 2000);
    } catch (error) {
      console.error('Error:', error);
    }
  }
  atcBtn.addEventListener('click', atcSubmit);
}

function findSectionInnerHTML(html, selector) {
  if (!html) return '';
  const parser = new DOMParser();
  const doc = parser.parseFromString(html, 'text/html');
  const element = doc.querySelector(selector);
  return element ? element.innerHTML : '';
}

function updateCartSections(parsedState) {
  getSectionsToRender().forEach((section) => {
    const elementToReplace = document.getElementById(section.id)?.querySelector(section.selector);
    if (!elementToReplace) {
      console.warn(`Element not found for id: ${section.id}`);
      return;
    }

    const innerHTMLValue = findSectionInnerHTML(parsedState.sections[section.section], section.selector);
    if (innerHTMLValue) {
      elementToReplace.innerHTML = innerHTMLValue;
    }
  });
  updateCartHeaderFooter();
}

function getSectionsToRender() {
  return [
    {
      id: 'main-cart-items',
      section: document.getElementById('main-cart-items').dataset.id,
      selector: '.js-contents',
    },
    {
      id: 'cart-icon-bubble',
      section: 'cart-icon-bubble',
      selector: '.shopify-section'
    },
    {
      id: 'cart-live-region-text',
      section: 'cart-live-region-text',
      selector: '.shopify-section'
    },
    {
      id: 'main-cart-footer',
      section: document.getElementById('main-cart-footer').dataset.id,
      selector: '.js-contents',
    }
  ];
}

function updateCartHeaderFooter (){
  const updatedCartURL = window.Shopify.routes.root + 'cart.js';
  const cartContents = fetch(updatedCartURL)
    .then(response => response.json())
    .then(data => {
      const shippingMin = window.theme.settings.cartThreshold;
      const cartTotal = parseFloat(data.total_price / 100);
      const cartCalc = parseFloat(shippingMin - cartTotal).toFixed(2).replace('.00', '');

      const totalPrice = document.querySelector('.totals__subtotal-value .money');
      totalPrice.innerHTML = `$${cartTotal.toFixed(2)}`;
      totalPrice.setAttribute('data-cart-total', cartTotal);

      const announcementBars = document.querySelectorAll('.announcement-bar__message.free-shipping, .countdown-text');
      announcementBars.forEach(announcementBar => {
        if (cartTotal >= shippingMin) {
          announcementBar.innerText = thresholdMsgAchieved;
        } else {
          announcementBar.innerText = `$${cartCalc} ${thresholdMsgUntil}`;
        }
      });

      const miniFooter = document.querySelector('.before-threshold');
      const miniFooterAmount = miniFooter.querySelector('.add-amount');
      if (cartTotal >= shippingMin) {
          miniFooter.style.display = 'none';
      } else {
          miniFooter.style.display = 'inline';
          miniFooterAmount.innerText = `$${cartCalc}`;
      }
  });
}

// FOXSELL: Multi-step bundler queue management
const bundlerQueue = {
  items: [],
  totalPrice: 0,
  firstItemAdded: false,
  categoryCounts: {},
  
  addItem(item) {
    // Check if we can add more items to this category
    if (!this.canAddMoreItems(item.category)) {
      console.warn(`Cannot add more items to category ${item.category}`);
      return;
    }

    // Ensure properties are properly formatted
    const formattedProperties = {
      ...item.properties,
      // Only override metal if mixed_metals is explicitly false
      Metal: (!FoxsellBundleConfig.allowsMixedMetals() && 
              FoxsellBundleConfig.lockedMetal) 
        ? FoxsellBundleConfig.lockedMetal 
        : (item.properties.Metal || item.properties.metal),
      // Add length/size if it exists in the properties
      ...(item.properties.Length && { Length: item.properties.Length }),
      ...(item.properties.Size && { Size: item.properties.Size }),
      ...(item.properties['Chain Length'] && { 'Chain Length': item.properties['Chain Length'] }),
      ...(item.properties['Chain Size'] && { 'Chain Size': item.properties['Chain Size'] })
    };

    const itemToAdd = {
      ...item,
      properties: formattedProperties
    };

    this.items.push(itemToAdd);
    this.totalPrice += (item.price * item.quantity);
    
    // Update category counts
    this.categoryCounts[item.category] = (this.categoryCounts[item.category] || 0) + 1;
    
    const modal = document.getElementById('bundler-preview-modal');
    if (!modal) {
      this.createPreviewModal();
    }
    
    this.renderPreviewContent();
    this.updateBundleButton();
    this.updateCheckoutButton();
    updateAllButtonStates();

    // Show modal and scroll to next category when we've reached the limit for this category
    if (!this.canAddMoreItems(item.category)) {
      modal.removeAttribute('hidden');
      const closeButton = modal.querySelector('.bundler-modal__close');
      closeButton.focus();

      // Find the next category to scroll to
      const currentCategory = FoxsellBundleConfig.getCategoryByTitle(item.category);
      const nextCategory = FoxsellBundleConfig.getNextCategory(currentCategory.title);
      
      if (nextCategory) {
        // Find the details element for the next category
        const nextDetails = document.querySelector(`details[data-step="${FoxsellBundleConfig.getCategoryIndex(nextCategory.title) + 1}"]`);
        if (nextDetails) {
          // Open the next category
          nextDetails.setAttribute('open', '');
          
          // Scroll to the next category with a smooth animation
          setTimeout(() => {
            nextDetails.scrollIntoView({ 
              behavior: 'smooth', 
              block: 'start'
            });
            
            // Focus the summary element for accessibility
            const nextSummary = nextDetails.querySelector('summary');
            if (nextSummary) {
              nextSummary.focus();
            }
          }, 300); // Small delay to ensure smooth transition
        }
      }
    }
  },
  
  removeItem(index) {
    if (this.items[index]) {
      const item = this.items[index];
      this.totalPrice -= (item.price * item.quantity);
      this.items.splice(index, 1);
      
      // Update category counts
      this.categoryCounts[item.category] = Math.max(0, (this.categoryCounts[item.category] || 0) - 1);
      
      this.renderPreviewContent();
      this.updateBundleButton();
      this.updateCheckoutButton();
      updateAllButtonStates();
    }
  },

  updateBundleButton() {
    const previewButton = document.getElementById('bundle-preview-button');
    const countElement = previewButton.querySelector('.bundle-preview-button__count');
    
    const totalItems = this.items.length;
    countElement.textContent = totalItems;
    previewButton.classList.toggle('has-items', totalItems > 0);
    previewButton.setAttribute('aria-expanded', 'false');
  },
  
  calculateDiscountedTotal() {
    const foxsellContainer = document.getElementById('foxsell-bundles');
    const discountStrategy = foxsellContainer.dataset.discountStrategy;
    
    // Calculate raw total
    const rawTotal = this.items.reduce((total, item) => 
      total + (item.price * item.quantity), 0);

    // Apply discount if available
    if (discountStrategy) {
      const discountMultiplier = (100 - parseFloat(discountStrategy)) / 100;
      return rawTotal * discountMultiplier;
    }

    return rawTotal;
  },

  getStepItemCount(categoryTitle) {
    return this.categoryCounts[categoryTitle] || 0;
  },

  canAddMoreItems(categoryTitle) {
    const currentCount = this.getStepItemCount(categoryTitle);
    const requiredQuantity = FoxsellBundleConfig.getRequiredQuantityForCategory(categoryTitle);
    const minRequired = FoxsellBundleConfig.getCategoryMinimum(categoryTitle);
    
    // If we have a minimum requirement, check if we've reached it
    if (minRequired !== null && currentCount < minRequired) {
      return true; // Allow adding more until we reach the minimum
    }
    
    // Otherwise, check against the maximum required quantity
    return currentCount < requiredQuantity;
  },

  isComplete() {
    return FoxsellBundleConfig.categories.every(cat => 
      this.isCategoryComplete(cat.title)
    );
  },

  isCategoryComplete(categoryTitle) {
    const currentCount = this.getStepItemCount(categoryTitle);
    const requiredQuantity = FoxsellBundleConfig.getRequiredQuantityForCategory(categoryTitle);
    const minRequired = FoxsellBundleConfig.getCategoryMinimum(categoryTitle);
    
    // If we have a minimum requirement, check if we've reached it
    if (minRequired !== null) {
      return currentCount >= minRequired && currentCount <= requiredQuantity;
    }
    
    // Otherwise, just check if we've reached the required quantity
    return currentCount >= requiredQuantity;
  },

  getRemainingItemsForCategory(categoryTitle) {
    const currentCount = this.getStepItemCount(categoryTitle);
    const requiredQuantity = FoxsellBundleConfig.getRequiredQuantityForCategory(categoryTitle);
    const minRequired = FoxsellBundleConfig.getCategoryMinimum(categoryTitle);
    
    if (minRequired !== null && currentCount < minRequired) {
      return minRequired - currentCount;
    }
    
    return Math.max(0, requiredQuantity - currentCount);
  },

  getNextIncompleteCategory() {
    return FoxsellBundleConfig.categories.find(cat => !this.isCategoryComplete(cat.title));
  },

  updateCheckoutButton() {
    const checkoutBtn = document.querySelector('.bundler-modal__checkout');
    if (!checkoutBtn) return;

    const isComplete = this.isComplete();
    checkoutBtn.disabled = !isComplete;
    checkoutBtn.classList.toggle('button--disabled', !isComplete);

    let message;
    if (isComplete) {
      message = 'Add to Cart';
    } else {
      const nextCategory = this.getNextIncompleteCategory();
      const remaining = this.getRemainingItemsForCategory(nextCategory.title);
      const minRequired = FoxsellBundleConfig.getCategoryMinimum(nextCategory.title);
      
      if (minRequired !== null) {
        const currentCount = this.getStepItemCount(nextCategory.title);
        if (currentCount < minRequired) {
          message = `Add ${remaining} more ${nextCategory.title}${remaining === 1 ? '' : 's'} (minimum ${minRequired})`;
        } else {
          message = `Add ${remaining} more ${nextCategory.title}${remaining === 1 ? '' : 's'} (maximum ${FoxsellBundleConfig.getRequiredQuantityForCategory(nextCategory.title)})`;
        }
      } else {
        message = `Add ${remaining} more ${nextCategory.title}${remaining === 1 ? '' : 's'}`;
      }
    }

    checkoutBtn.textContent = message;
  },

  renderPreviewContent() {
    const modal = document.getElementById('bundler-preview-modal');
    const itemsContainer = modal.querySelector('.bundler-modal__items');
    const totalSpan = modal.querySelector('.bundler-modal__total span');
    const subtotalSpan = modal.querySelector('.bundler-modal__subtotal span');
    const discountSpan = modal.querySelector('.bundler-modal__discount');
    
    itemsContainer.innerHTML = '';
    
    // Use existing foxsellContainer reference
    const isMultiStep = document.getElementById('foxsell-bundles').classList.contains('multi-step-bundler');
    
    // Group items by category for proper numbering
    const itemsByCategory = {};
    this.items.forEach(item => {
      if (!itemsByCategory[item.category]) {
        itemsByCategory[item.category] = [];
      }
      itemsByCategory[item.category].push(item);
    });

    // Render items grouped by category
    Object.entries(itemsByCategory).forEach(([category, items]) => {
      items.forEach((item, categoryIndex) => {
        // Only calculate display placement for multistep bundler
        let displayPlacement = '';
        if (isMultiStep) {
          if (item.category === 'Step 1' || item.category === 'Chain') {
            displayPlacement = 'chain';
          } else if (item.category === 'Step 2' || item.category.includes('Charm')) {
            // Add 1 to make charm positions start at 1 instead of 0
            displayPlacement = `charm ${categoryIndex + 1}`;
          }
        }

        // Format properties for display, excluding internal properties and stepCategory
        const displayProperties = Object.entries(item.properties)
          .filter(([key]) => !key.startsWith('_') && key !== 'stepCategory') // Exclude internal properties and stepCategory
          .map(([key, value]) => {
            // Format the property name for display by adding spaces before capital letters
            const displayName = key.replace(/([A-Z])/g, ' $1').trim();
            return `<span class="bundler-modal__item-property">${displayName}: ${value}</span>`;
          })
          .join('');

        const itemHTML = `
          <div class="bundler-modal__item" 
               role="listitem"
               data-index="${this.items.indexOf(item)}">
            ${displayPlacement ? `<h3 class="bundler-modal__item-placement">${displayPlacement}</h3>` : ''}
            <div class="bundler-modal__item-image">
              <img src="${item.image}" 
                   alt="" 
                   loading="lazy"
                   aria-hidden="true">
            </div>
            <div class="bundler-modal__item-details">
              <span class="bundler-modal__item-title">${item.title}</span>
              <span class="bundler-modal__item-options">
                ${displayProperties}
              </span>
              <span class="bundler-modal__item-price" aria-label="Price: $${(item.price * item.quantity / 100).toFixed(2)}">
                $${(item.price * item.quantity / 100).toFixed(2)}
              </span>
            </div>
            <button class="bundler-modal__item-remove" 
                    aria-label="Remove ${item.title} from bundle">×</button>
          </div>
        `;
        itemsContainer.insertAdjacentHTML('beforeend', itemHTML);
      });
    });
    
    // Calculate and display pricing
    const rawTotal = this.totalPrice;
    const discountedTotal = this.calculateDiscountedTotal();
    
    // Update subtotal (pre-discount)
    if (subtotalSpan) {
      subtotalSpan.textContent = (rawTotal / 100).toFixed(2);
    }

    // Update discount if applicable
    const foxsellContainer = document.getElementById('foxsell-bundles');
    const discountStrategy = foxsellContainer.dataset.discountStrategy;
    
    if (discountSpan && discountStrategy) {
      discountSpan.innerHTML = `
        <span class="bundler-modal__discount-label">Bundle Discount (${discountStrategy}% off):</span>
        <span class="bundler-modal__discount-value">-$${((rawTotal - discountedTotal) / 100).toFixed(2)}</span>
      `;
      discountSpan.style.display = 'flex';
    }

    // Update final total
    totalSpan.textContent = (discountedTotal / 100).toFixed(2);
    
    itemsContainer.querySelectorAll('.bundler-modal__item-remove').forEach(btn => {
      btn.addEventListener('click', (e) => {
        const index = parseInt(e.target.closest('.bundler-modal__item').dataset.index);
        this.removeItem(index);
      });
    });
  },

  createPreviewModal() {
    const modalHTML = `
      <div id="bundler-preview-modal" class="bundler-modal" hidden>
        <div class="bundler-modal__content">
          <button class="bundler-modal__close" aria-label="Close preview">×</button>
          <h2 class="bundler-modal__title">Your Bundle</h2>
          <div class="bundler-modal__items" role="list"></div>
          <div class="bundler-modal__pricing">
            <div class="bundler-modal__subtotal">
              <span class="bundler-modal__subtotal-label">Subtotal:</span>
              <span class="bundler-modal__subtotal-value">$<span>0.00</span></span>
            </div>
            <div class="bundler-modal__discount" style="display: none;">
              <!-- Discount will be inserted here when applicable -->
            </div>
            <div class="bundler-modal__total">
              <span class="bundler-modal__total-label">Total:</span>
              <span class="bundler-modal__total-value">$<span>0.00</span></span>
            </div>
          </div>
          <div class="bundler-modal__actions">
            <button class="bundler-modal__checkout button button--primary">
              Add Bundle to Cart
            </button>
          </div>
        </div>
      </div>
    `;
    document.body.insertAdjacentHTML('beforeend', modalHTML);
  },

  resetQueue() {
    // Clear the queue
    this.items = [];
    this.totalPrice = 0;
    
    // Update UI elements
    this.renderPreviewContent();
    this.updateBundleButton();
    this.updateCheckoutButton();
    
    // Reset form elements
    const foxsellBundler = document.getElementById('foxsell-bundles');
    
    // Reset all radio inputs
    foxsellBundler.querySelectorAll('input[type="radio"]').forEach(input => {
      input.checked = false;
    });

    // Reset all selects
    foxsellBundler.querySelectorAll('select').forEach(select => {
      select.selectedIndex = 0;
    });

    // Reset all buttons
    foxsellBundler.querySelectorAll('.custom-atc-btn').forEach(button => {
      button.disabled = true;
      button.textContent = "Choose Options";
    });

    // Reset accordion state
    foxsellBundler.querySelectorAll('details').forEach((details, index) => {
      if (index === 0) {
        details.setAttribute('open', '');
      } else {
        details.removeAttribute('open');
      }
    });

    // Update all button states
    updateAllButtonStates();
  }
};

// Remove the event listener from DOMContentLoaded and add it in the bundlerQueue
document.addEventListener('DOMContentLoaded', () => {
  const checkoutBtn = document.querySelector('.bundler-modal__checkout');
  if (checkoutBtn) {
    // Remove any existing click listeners
    checkoutBtn.replaceWith(checkoutBtn.cloneNode(true));
    const newCheckoutBtn = document.querySelector('.bundler-modal__checkout');
    
    // Add the bundler items to cart when clicked
    addBundlerItemsToCart(newCheckoutBtn, bundlerQueue.items);
  }
});

// Initialize modal controls
function initializeBundleUI() {
  const modal = document.getElementById('bundler-preview-modal');
  const previewButton = document.getElementById('bundle-preview-button');
  
  // Exit early if modal or preview button doesn't exist
  if (!modal || !previewButton) return;
  
  const closeBtn = modal.querySelector('[data-action="close"]');
  const overlay = modal.querySelector('.bundler-modal__overlay');

  // Show modal only on button click
  previewButton.addEventListener('click', () => {
    modal.removeAttribute('hidden');
    previewButton.setAttribute('aria-expanded', 'true');
    
    // Focus management
    const closeButton = modal.querySelector('.bundler-modal__close');
    if (closeButton) {
      closeButton.focus();
    }
  });

  // Handle modal closing
  const closeModal = () => {
    modal.setAttribute('hidden', '');
    previewButton.setAttribute('aria-expanded', 'false');
    previewButton.focus();
  };

  // Hide modal
  [closeBtn, overlay].forEach(el => {
    if (el) {
      el.addEventListener('click', closeModal);
    }
  });

  // Keyboard handling
  modal.addEventListener('keydown', (e) => {
    if (e.key === 'Escape') {
      closeModal();
    }
  });

  // Prevent body scroll when modal is open
  const observer = new MutationObserver((mutations) => {
    mutations.forEach((mutation) => {
      if (mutation.attributeName === 'hidden') {
        document.body.style.overflow = modal.hasAttribute('hidden') ? '' : 'hidden';
      }
    });
  });

  observer.observe(modal, { attributes: true });
}

// Move stepSelections to global scope
const stepSelections = {
  1: { required: 1, selected: 0 }, // First step requires 1 selection
  2: { required: 5, selected: 0 }  // Second step requires 5 selections
};

function bundlerVarsHandler() {
  const foxsellBundler = document.getElementById('foxsell-bundles');
  
  // Exit early if foxsell bundler doesn't exist
  if (!foxsellBundler) return;
  
  const bundlerVars = foxsellBundler.querySelectorAll('variant-radios[data-multi-step-bundler="true"]');
  
  bundlerVars.forEach(variantRadios => {
    const step = parseInt(variantRadios.dataset.foxsellBundleStep);
    const gridItem = variantRadios.closest('.grid__item');
    const customAtcBtn = gridItem?.querySelector('.custom-atc-btn');

    if (!customAtcBtn) return;

    // Get the category for this step
    const category = FoxsellBundleConfig.categories[step - 1];
    if (!category) return;

    // Set up event listeners for all inputs
    const radioInputs = variantRadios.querySelectorAll('input[type="radio"]');
    const dropdownSelects = variantRadios.querySelectorAll('select');

    // Add change event listeners to all radio inputs (including metal)
    radioInputs.forEach(input => {
      input.addEventListener('change', () => {
        checkCategoryCompletion(variantRadios, customAtcBtn);
      });
    });

    // Add change event listeners to dropdowns
    dropdownSelects.forEach(select => {
      select.addEventListener('change', () => {
        checkCategoryCompletion(variantRadios, customAtcBtn);
      });
    });

    // Also listen for the product selection radio
    const productRadio = gridItem.querySelector('input.add_on_radio_button');
    if (productRadio) {
      productRadio.addEventListener('change', () => {
        checkCategoryCompletion(variantRadios, customAtcBtn);
      });
    }

    // Update step click handler
    customAtcBtn.addEventListener('click', (e) => {
      e.preventDefault();
      if (customAtcBtn.disabled || !customAtcBtn.dataset.selectedVariantId) return;
      
      // Check limits before adding
      if (bundlerQueue.getStepItemCount(category.title) >= category.quantity) {
        customAtcBtn.disabled = true;
        customAtcBtn.textContent = `${category.title} Limit Reached`;
        return;
      }

      // Get current item count for this category
      const currentCount = bundlerQueue.getStepItemCount(category.title) + 1;

      // Build properties object from all stored selections
      const properties = {
        Metal: customAtcBtn.dataset.metal,
        _placement: `${category.title.toLowerCase()} ${currentCount}`,  // Hidden property for placement
      };

      // Add all other selected options to properties
      Object.entries(customAtcBtn.dataset).forEach(([key, value]) => {
        if (key !== 'selectedVariantId' && key !== 'selectedPrice' && key !== 'metal') {
          properties[key] = value;
        }
      });

      const itemToAdd = {
        category: category.title,
        variantId: customAtcBtn.dataset.selectedVariantId,
        quantity: 1,
        type: 'product',
        price: parseInt(customAtcBtn.dataset.selectedPrice),
        properties,
        image: variantRadios.closest('.grid__item').querySelector('img.meta_bundler-image')?.src || '',
        title: variantRadios.closest('.grid__item').querySelector('label[data-product-title]')?.dataset.productTitle || ''
      };

      bundlerQueue.addItem(itemToAdd);
      
      // Update button text to show count
      const variantCount = getVariantCount(customAtcBtn.dataset.selectedVariantId);
      customAtcBtn.textContent = `In Bundle +${variantCount}`;

      if (bundlerQueue.getStepItemCount(category.title) < category.quantity) {
        setTimeout(() => {
          handleAccordionTransition(step);
        }, 1000);
      }
    });
  });
}

function checkCategoryCompletion(variantRadios, customAtcBtn) {
  const category = variantRadios.closest('.bundler-category').dataset.category;
  const selectedMetal = variantRadios.querySelector('input.is-metal:checked');
  
  // Only lock metal if mixed_metals is explicitly false
  if (selectedMetal && 
      category === FoxsellBundleConfig.categories[0].title &&
      !FoxsellBundleConfig.allowsMixedMetals() &&
      !FoxsellBundleConfig.lockedMetal) {
    FoxsellBundleConfig.lockedMetal = selectedMetal.value;
  }
  
  // Get all option inputs for this product
  const optionInputs = Array.from(variantRadios.querySelectorAll('fieldset input[type="radio"]:checked'));
  const dropdownSelects = Array.from(variantRadios.querySelectorAll('select'));

  // Get the product handle to fetch variant data
  const productHandle = selectedMetal?.dataset.productHandle;
  if (!productHandle) {
    customAtcBtn.disabled = true;
    customAtcBtn.textContent = "Choose Options";
    return;
  }

  const varScript = document.getElementById(`${productHandle}-vars`);
  if (!varScript) {
    console.warn('No variant script found for product:', productHandle);
    return;
  }

  const variantData = JSON.parse(varScript.textContent);
  
  // Get the number of options this product has from the first variant
  const requiredOptionCount = variantData[0]?.options?.length || 0;
  
  // Build array of all selected options in order, removing duplicates
  const selectedOptions = [
    selectedMetal.value,
    ...optionInputs.map(input => input.value),
    ...dropdownSelects.map(select => select.value)
  ].filter((value, index, self) => self.indexOf(value) === index); // Remove duplicates
  
  
  // Check if we have all required options selected
  const hasAllRequiredOptions = selectedOptions.length === requiredOptionCount;
  
  if (!hasAllRequiredOptions) {
    customAtcBtn.disabled = true;
    customAtcBtn.textContent = "Choose Options";
    return;
  }

  // Find matching variant based on all selected options
  const matchingVariant = findMatchingVariant(variantData, ...selectedOptions);
  
  if (matchingVariant) {    
    // Find the container to update
    const container = variantRadios.closest('.meta_bundler_prod.grid__item');
    updateVariantDetails(matchingVariant, container);

    const isInBundle = bundlerQueue.items.some(item => 
      item.variantId === matchingVariant.id.toString()
    );

    // Check both available flag and inventory quantity
    const isAvailable = matchingVariant.available && 
                      (matchingVariant.inventory_policy === "continue" || 
                       matchingVariant.inventory_quantity > 0);

    if (!isAvailable) {
      customAtcBtn.disabled = true;
      customAtcBtn.textContent = "Out of Stock";
      customAtcBtn.classList.add('unavailable');
    } else {
      customAtcBtn.disabled = isInBundle;
      customAtcBtn.textContent = isInBundle ? "In Bundle" : "Add to Bundle";
      customAtcBtn.classList.remove('unavailable');
      
      // Update button data with all selected options
      customAtcBtn.dataset.selectedVariantId = matchingVariant.id;
      customAtcBtn.dataset.selectedPrice = matchingVariant.price;
      
      // Store all selected options in the dataset
      optionInputs.forEach(input => {
        const optionName = input.name.split('-')[0].toLowerCase();
        // Convert property names with spaces to camelCase for dataset
        const datasetName = optionName.replace(/\s+([a-z])/g, (g) => g[1].toUpperCase());
        customAtcBtn.dataset[datasetName] = input.value;
      });
      
      // Store dropdown selections
      dropdownSelects.forEach(select => {
        const propertyName = select.name.split('-')[0].toLowerCase();
        // Convert property names with spaces to camelCase for dataset
        const datasetName = propertyName.replace(/\s+([a-z])/g, (g) => g[1].toUpperCase());
        customAtcBtn.dataset[datasetName] = select.value;
      });
    }
  } else {
    customAtcBtn.disabled = true;
    customAtcBtn.textContent = "Choose Options";
  }
}

function updateVariantDetails(matchingVariant, container) {
  if (!matchingVariant || !container) return;

  // Find the price element and update it
  const priceElement = container.querySelector('.price-item');
  if (priceElement) {
    const formattedPrice = (matchingVariant.price / 100).toLocaleString('en-US', {
      style: 'currency',
      currency: 'USD'
    });
    priceElement.textContent = formattedPrice;
  }

  // Find and update the image if the variant has a featured image
  const imageElement = container.querySelector('img.meta_bundler-image');
  if (imageElement && 
      matchingVariant.featured_image && 
      matchingVariant.featured_image.src) {
    imageElement.src = matchingVariant.featured_image.src + '&crop=center&height=350&v=1738266310&width=250';
    imageElement.srcset = matchingVariant.featured_image.src + '&crop=center&height=350&v=1738266310&width=250';
  }
}

function findMatchingVariant(variantData, ...selectedValues) {

  // First, determine how many options this product has from the first variant
  const optionsCount = variantData[0]?.options?.length || 0;
  
  // Clean and filter the selected values, but only take as many as we need
  const cleanSelectedValues = selectedValues
    .filter(Boolean)
    .map(value => value.trim())
    .slice(0, optionsCount); // Only take the number of options we need

  const matchingVariant = variantData.find(variant => {
    // Clean the variant options
    const cleanedOptions = variant.options
      .map(opt => opt.replace(/\\"/g, '').replace(/"/g, '').trim())
      .filter(opt => opt !== "1" && opt !== "");

    // Check if all selected values match the variant options in order
    return cleanSelectedValues.every((value, index) => 
      cleanedOptions[index] === value
    );
  });
  return matchingVariant;
}

function handleAccordionTransition(completedStep) {
  const currentDetails = document.querySelector(`details[data-step="${completedStep}"]`);
  const nextDetails = document.querySelector(`details[data-step="${completedStep + 1}"]`);

  if (currentDetails && nextDetails) {
    // First close current step
    currentDetails.removeAttribute('open');
    
    // Small delay to ensure smooth transition
    setTimeout(() => {
      // Open next step
      nextDetails.setAttribute('open', '');
      
      // Scroll next section into view and focus its summary
      nextDetails.scrollIntoView({ behavior: 'smooth', block: 'start' });
      const nextSummary = nextDetails.querySelector('summary');
      if (nextSummary) {
        nextSummary.focus();
      }
    }, 300); // Adjust timing as needed
  }
}

// This will now have access to stepSelections
document.querySelectorAll('details[data-step]').forEach(details => {
  details.addEventListener('toggle', (event) => {
    const step = parseInt(details.dataset.step);
    
    // Safety checks
    if (isNaN(step)) return; // Make sure step is a valid number
    if (!stepSelections || !stepSelections[step]) return; // Make sure stepSelections exists and has this step
    
    // Only prevent closing if we have valid step selections and requirements aren't met
    if (!details.open && 
        stepSelections[step].selected !== undefined && 
        stepSelections[step].required !== undefined && 
        stepSelections[step].selected < stepSelections[step].required) {
      event.preventDefault();
      details.setAttribute('open', '');
    }
  });
});

// Initialize
document.addEventListener('DOMContentLoaded', () => {
  initializeBundleUI();
  bundlerVarsHandler();
  updateAllButtonStates();
  
  // Initialize flatback bundler if present
  initializeFlatbackBundler();
});

// Add this new function to handle button states
function updateAllButtonStates() {
  const foxsellBundler = document.getElementById('foxsell-bundles');
  
  // Exit early if foxsell bundler doesn't exist
  if (!foxsellBundler) return;
  
  // Get all categories from config
  const categories = FoxsellBundleConfig.categories;
  
  // Update buttons for each category
  categories.forEach(category => {
    const categoryButtons = foxsellBundler.querySelectorAll(`[data-step-category="${category.title}"]`);
    const currentCount = bundlerQueue.getStepItemCount(category.title);
    const requiredQuantity = FoxsellBundleConfig.getRequiredQuantityForCategory(category.title);
    
    categoryButtons.forEach(button => {
      if (currentCount >= requiredQuantity) {
        button.disabled = true;
        button.textContent = `${category.title} Limit Reached`;
      } else if (!button.dataset.selectedVariantId) {
        button.disabled = true;
        button.textContent = "Choose Options";
      } else {
        // Check if previous categories are complete
        const previousCategories = categories.slice(0, categories.indexOf(category));
        const allPreviousComplete = previousCategories.every(prevCat => 
          bundlerQueue.isCategoryComplete(prevCat.title)
        );
        
        if (!allPreviousComplete) {
          button.disabled = true;
          button.textContent = `Complete ${previousCategories.find(cat => !bundlerQueue.isCategoryComplete(cat.title)).title} First`;
        } else {
          button.disabled = false;
          const variantCount = getVariantCount(button.dataset.selectedVariantId);
          button.textContent = variantCount > 0 ? `In Bundle +${variantCount}` : "Add to Bundle";
        }
      }
    });
  });
}

// Add a helper function to count specific variants in the queue
function getVariantCount(variantId) {
  return bundlerQueue.items.filter(item => item.variantId === variantId).length;
}

// Global flatback bundle configuration
let flatbackBundleConfig = {
  fronts: null,
  backs: null,
  totalPrice: 0
};

// Flatback Bundler Functions
function initializeFlatbackBundler() {
  const flatbackBundler = document.getElementById('foxsell-bundles-flatback');
  if (!flatbackBundler) return;
  
  // console.log('Initializing Flatback Bundler');
  
  // Wait for FoxsellBundleConfig to be ready
  const initConfig = () => {
    if (!window.foxsell?.bundleConfig) {
      console.warn('Waiting for foxsell bundle config...');
      setTimeout(initConfig, 100);
      return;
    }
    
    // Make sure FoxsellBundleConfig is initialized
    if (!FoxsellBundleConfig._initialized) {
      FoxsellBundleConfig.init();
    }
    
    setupFlatbackBundler();
  };
  
  initConfig();
  
  function setupFlatbackBundler() {
  
  // Reset the bundle configuration
  flatbackBundleConfig = {
    fronts: null,
    backs: null,
    totalPrice: 0
  };
  
  // Get all dropdowns
  const dropdowns = flatbackBundler.querySelectorAll('.bundler-variant-select');
  
  // Add change listeners to all dropdowns
  dropdowns.forEach(dropdown => {
    dropdown.addEventListener('change', (e) => {
      // Stop propagation to prevent Shopify's variant change handlers
      e.stopPropagation();
      e.stopImmediatePropagation();
      handleFlatbackDropdownChange(dropdown, flatbackBundleConfig, flatbackBundler);
    });
  });
  
  // Use the existing add to cart button
  const addToCartButton = document.getElementById('addToCartButton');
  
  if (!addToCartButton) {
    console.error('Add to cart button not found');
    return;
  }
  
  // Store original button text
  const originalButtonText = addToCartButton.textContent;
  
  // Set initial button state to guide user
  const buttonTextElement = addToCartButton.querySelector('span') || addToCartButton;
  buttonTextElement.textContent = 'Choose your fronts';
  addToCartButton.disabled = true;
  
  // Store reference to flatback bundler on the button for later checks
  addToCartButton.dataset.flatbackBundler = 'true';
  
  // Add click handler for add to cart
  addToCartButton.addEventListener('click', (e) => {
    // Only handle if we have selections
    if (flatbackBundleConfig.fronts && flatbackBundleConfig.backs) {
      e.preventDefault();
      handleFlatbackAddToCart(flatbackBundleConfig, flatbackBundler);
    }
  });
  }
}

function handleFlatbackDropdownChange(dropdown, bundleConfig, flatbackBundler) {
  const categoryDiv = dropdown.closest('.bundler-category');
  const categoryTitle = categoryDiv.dataset.category;
  const productGroup = dropdown.closest('.bundler-product-group');
  const productId = productGroup.dataset.productId;
  
  // console.log('Dropdown changed for category:', categoryTitle);
  
  // Get all dropdowns in this product group
  const productDropdowns = productGroup.querySelectorAll('.bundler-variant-select');
  const allSelected = Array.from(productDropdowns).every(d => d.value !== '');
  
  // console.log('All dropdowns selected:', allSelected);
  
  if (allSelected) {
    // Find the matching variant - look for the script with -vars suffix
    const variantScript = productGroup.querySelector('script[id$="-vars"]');
    if (!variantScript) {
      console.error('Variant data script not found');
      return;
    }
    
    const variantData = JSON.parse(variantScript.textContent);
    const selectedOptions = Array.from(productDropdowns).map(d => d.value);
    
    // console.log('Selected options:', selectedOptions);
    // console.log('Variant data:', variantData);
    
    const matchingVariant = findMatchingVariant(variantData, ...selectedOptions);
    
    // console.log('Matching variant:', matchingVariant);
    
    if (matchingVariant) {
      // Store the selection based on category
      if (categoryTitle.toLowerCase().includes('front')) {
        bundleConfig.fronts = {
          variantId: matchingVariant.id,
          price: matchingVariant.price,
          title: matchingVariant.title || matchingVariant.name,
          productId: productId,
          category: categoryTitle
        };
        // console.log('Set fronts:', bundleConfig.fronts);
      } else if (categoryTitle.toLowerCase().includes('back')) {
        bundleConfig.backs = {
          variantId: matchingVariant.id,
          price: matchingVariant.price,
          title: matchingVariant.title || matchingVariant.name,
          productId: productId,
          category: categoryTitle
        };
        // console.log('Set backs:', bundleConfig.backs);
      }
      
      // Update total price and button state
      updateFlatbackBundleState(bundleConfig, flatbackBundler);
    } else {
      console.error('No matching variant found for options:', selectedOptions);
    }
  }
}

function updateFlatbackBundleState(bundleConfig, flatbackBundler) {
  const addToCartButton = document.getElementById('addToCartButton');
  
  if (!addToCartButton) {
    console.error('Add to cart button not found');
    return;
  }
  
  // console.log('Updating bundle state:', bundleConfig);
  
  // Get button text element
  const buttonTextElement = addToCartButton.querySelector('span') || addToCartButton;
  
  // Check if both fronts and backs are selected
  if (bundleConfig.fronts && bundleConfig.backs) {
    bundleConfig.totalPrice = bundleConfig.fronts.price + bundleConfig.backs.price;
    
    // Apply discount if configured
    const discountStrategy = flatbackBundler.dataset.discountStrategy;
    if (discountStrategy) {
      const discountPercent = parseInt(discountStrategy);
      bundleConfig.totalPrice = bundleConfig.totalPrice * (1 - discountPercent / 100);
    }
    
    // console.log('Enabling button');
    
    // Use setTimeout to ensure our changes happen after any other scripts
    setTimeout(() => {
      // Force button update for Shopify buttons
      addToCartButton.disabled = false;
      addToCartButton.removeAttribute('disabled');
      addToCartButton.setAttribute('aria-disabled', 'false');
      
      // Update button text to show it's ready
      buttonTextElement.textContent = 'Add to Cart';
      
      // Remove any 'unavailable' or 'disabled' classes
      addToCartButton.classList.remove('disabled', 'unavailable', 'btn--disabled', 'button--unavailable');
      addToCartButton.classList.add('btn--primary', 'button--primary');
      
      // If it's a Shopify button, it might have a parent that needs updating too
      const buttonWrapper = addToCartButton.closest('.product-form__buttons');
      if (buttonWrapper) {
        buttonWrapper.classList.remove('disabled');
      }
      
      // Also check for form element that might control button state
      const form = addToCartButton.closest('form');
      if (form) {
        form.classList.remove('product-form--unavailable');
      }
      
      // console.log('Button state after update:', {
      //   disabled: addToCartButton.disabled,
      //   classList: addToCartButton.className,
      //   text: addToCartButton.textContent
      // });
    }, 10);
  } else {
    // Determine which category needs selection
    if (!bundleConfig.fronts) {
      // First category needs selection
      buttonTextElement.textContent = 'Choose your fronts';
    } else if (!bundleConfig.backs) {
      // Second category needs selection
      buttonTextElement.textContent = 'Choose your backs';
    }
    
    // console.log('Not all selections made, button text:', buttonTextElement.textContent);
    addToCartButton.disabled = true;
    addToCartButton.setAttribute('aria-disabled', 'true');
  }
}

function handleFlatbackAddToCart(bundleConfig, flatbackBundler) {
  if (!bundleConfig.fronts || !bundleConfig.backs) return;
  
  // Build selectedProducts array in the same format as regular bundler
  const selectedProducts = [
    {
      category: bundleConfig.fronts.category,
      variantId: bundleConfig.fronts.variantId,
      quantity: 1,
      type: 'product',
      price: bundleConfig.fronts.price,
      properties: {
        _placement: 'fronts 1'
      }
    },
    {
      category: bundleConfig.backs.category,
      variantId: bundleConfig.backs.variantId,
      quantity: 1,
      type: 'product',
      price: bundleConfig.backs.price,
      properties: {
        _placement: 'backs 1'
      }
    }
  ];
  
  // Build bundleLineItemProperties following the same pattern
  const bundleLineItemProperties = selectedProducts.map(product => {
    return {
      variantId: product.variantId,
      quantity: product.quantity,
      category: product.category,
      type: product.type,
      properties: product.properties
    };
  });
  
  // Use the existing addBundlerItemsToCart function
  const addToCartButton = document.getElementById('addToCartButton');
  
  // Temporarily create event handler for the button
  async function flatbackAtcSubmit(event) {
    event.preventDefault();
    
    const bundleId = flatbackBundler.dataset.bundleId;
    const currentBundleVariant = flatbackBundler.dataset.currentBundleVariant;
    const currentDate = Date.now();
    const identifier = `${bundleId}_${currentDate}`;
    
    const addToCartFormData = [{
      id: currentBundleVariant,
      quantity: 1,
      properties: {
        "__foxsell:dynamic_add_on_bundle_id": identifier,
        "__foxsell:dynamic_add_on_bundle_items": JSON.stringify(bundleLineItemProperties)
      }
    }];
    
    let bundlerItems = {
      items: addToCartFormData,
      sections: getSectionsToRender().map((section) => section.section),
      sections_url: window.location.pathname
    };
    
    try {
      let response = await fetch(`/cart/add.js`, {
        method: 'POST',
        headers: {'Content-Type': 'application/json'},
        body: JSON.stringify(bundlerItems)
      });
      
      if (!response.ok) {
        throw new Error(`Something is up! Status: ${response.status}`);
      }
      
      const cartNotification = document.getElementById('cart-notification');
      if (cartNotification) {
        cartNotification.classList.add('active');
        cartNotification.focus();
      }
      
      let notEmptyCart = document.getElementById('shopify-section-mini-cart');
      if (notEmptyCart) {
        notEmptyCart.querySelector('.mini-cart-container')?.classList.add('not-empty');
      }
      
      const parsedState = await response.json();
      const buttonTextElement = addToCartButton.querySelector('span') || addToCartButton;
      buttonTextElement.textContent = "Added to Bag";
      
      // Only update cart sections if the elements exist
      if (document.getElementById('main-cart-items') && document.getElementById('main-cart-footer')) {
        await updateCartSections(parsedState);
      }
      
      setTimeout(() => {
        buttonTextElement.textContent = "Add to Cart";
        // Reset the bundle config
        flatbackBundleConfig.fronts = null;
        flatbackBundleConfig.backs = null;
        flatbackBundleConfig.totalPrice = 0;
        // Reset dropdowns
        flatbackBundler.querySelectorAll('.bundler-variant-select').forEach(select => {
          select.selectedIndex = 0;
        });
        // Update button state
        updateFlatbackBundleState(flatbackBundleConfig, flatbackBundler);
      }, 2000);
      
    } catch (error) {
      console.error('Error:', error);
    }
  }
  
  // Trigger the submission
  flatbackAtcSubmit(new Event('click'));
}

// Helper function to format money
function formatMoney(cents) {
  return '$' + (cents / 100).toFixed(2);
}